<template>
  <div class="recommendation-progress">
    <div v-if="loading">{{ !error ? 'Loading...' : 'Error' }}</div>
    <div v-if="!loading" class="status">{{ recommendationsCompleted }}/{{ recommendationsTotal }}</div>
    <div v-if="!loading" class="progress">
      <div v-show="recommendationsTotal > 0" class="bar" :style="{ width: percentage * 100 + 1 + '%' }"></div>
    </div>
  </div>
</template>

<script>
import { TRAIL_RECOMMENDATION_PROGRESS_REQ } from '@/store/modules/trails/trailsinfo.type'
export default {
  name: 'RecommendationProgress',
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      error: false,
      loaded: false,
      loading: true,
      percentage: 0.1,
      recommendationsCompleted: 0,
      recommendationsTotal: 0
    }
  },
  mounted () {
    let rowData = this.rowData
    if (!this.loaded) {
      this.$store.dispatch(TRAIL_RECOMMENDATION_PROGRESS_REQ, rowData.id).then(
        details => {
          this.recommendationsCompleted = details.completed
          this.recommendationsTotal = details.total
          this.percentage = details.completed / details.total

          this.loading = false
          this.loaded = true
        },
        errors => {
          this.error = true
          this.loading = true
        }
      )
    }
  }
}
</script>

<style scoped>
.recommendation-progress {
  position: relative;
  height: 24px;
  margin: 10px 0 0 0;

  .progress {
    height: 10px;
    background: #f0f0f0;

    .bar {
      height: 10px;
      background: #0090ff;
    }
  }

  .status {
    position: absolute;
    top: 14px;
    left: 0;
    width: 100%;
    font-size: 10px;
    font-weight: bold;
    line-height: 10px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/chart/RecommendationProgress.vue